module.exports = __webpack_public_path__ + "static/media/answer-correct.ecf0fda5.mp3";